import { Grid } from '@mui/material';

import { NotesParent } from '../../../components/communicationBar/Notes';
import ComposeNote from '../../../features/clientDetails/components/notes/ComposeNote';

const NotesListing = () => {
  return (
    <Grid>
      <ComposeNote parentId={''} parent={NotesParent.NOTELISTING} />
    </Grid>
  );
};
export default NotesListing;
